/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import Component from '@glimmer/component';

interface SpecificArgs {
  datePickerDisabled: boolean;
  errors: string[];
  liquidExpression: string | undefined;
  timeframeUnits: string;
  selectedDate: Date | undefined;
  selectedType: string;
  onTypeChange: (selectedType: string) => unknown;
  onExpirationChange: (seconds: number) => unknown;
  onLiquidChange: (value: number) => unknown;
  onDateChange: (val: { date: moment.Moment } | null) => unknown;
}

export default class Specific extends Component<SpecificArgs> {
  @action
  changeSpecificInputType(val: 'date' | 'liquid') {
    this.args.onTypeChange(val);
  }

  @action
  setAbsoluteExpiration(val: { date: moment.Moment } | null) {
    this.args.onDateChange(val);
  }
}
